// 🔒
const heroMockup = new URL("../assets/phone-mockup.webp", import.meta.url).href;

export default function HeroSection() {
  return (
    <section className="hero section" id="home">
      <div className="container hero__content">
        <div className="hero__text">
          <p className="eyebrow">PREMIUM FITNESS PLATFORM</p>

          <h1>Elevate Your Fitness. Monetize Your Expertise.</h1>

          <p className="hero__description">
            The premium ecosystem where professional coaching meets structured
            performance. Whether you are a trainer building a digital legacy or
            an athlete seeking elite results, EleFit is your platform for
            growth.
          </p>

          <div className="hero__actions">
            <a href="#download" className="btn btn--primary">
              Download App
            </a>

            <a href="#trainer-benefits" className="btn btn--primary">
              Become a Partner
            </a>
          </div>
        </div>

        <div className="hero__visual">
          <div className="hero__glow hero__glow--one" />
          <div className="hero__glow hero__glow--two" />

          <div className="hero__imageWrap">
            <img
              src={heroMockup}
              alt="EleFit hero mockup"
              className="hero__mainImage"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
// 🔒